import axios from 'axios'
import { Tooltip, Offcanvas, Modal } from 'bootstrap'
import feather from 'feather-icons'
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import FsLightbox from 'fslightbox'


function createElementFromHTML(htmlString) {
  var div = document.createElement('div');
  div.innerHTML = htmlString.trim();

  // Change this to div.childNodes to support multiple top-level nodes.
  return div.firstChild;
}

document.querySelectorAll('.my-lightbox-toggle').forEach((el) => el.addEventListener('click', (e) => {
  e.preventDefault();
  const lightbox = new Lightbox(el);
  lightbox.show();
}));

axios.defaults.xsrfHeaderName = 'X-CSRFToken'
axios.defaults.xsrfCookieName = '_sp_csrf'

// feather.replace()
//
// const lightbox = new PhotoSwipeLightbox({
//   gallery: '#Gallery',
//   children: 'a',
//   pswpModule: () => import('photoswipe')
// });
// lightbox.init();

const cart = {
  add: function (pk, quantity) {
    quantity = quantity || 1
    return axios({
      method: 'post',
      url: '/cart/add/',
      data: {pk: pk, quantity: quantity},
      headers: {'Content-Type': 'multipart/form-data'}
    })
  },
  remove: function (itemPK) {
    return axios({
      method: 'post',
      url: '/cart/remove/',
      data: {pk: itemPK},
      headers: {'Content-Type': 'multipart/form-data'}
    })
  },
  changeQuantity: function (pk, quantity) {
    return axios({
      method: 'post',
      url: '/cart/change-quantity/',
      data: {pk: pk, quantity: quantity},
      headers: {'Content-Type': 'multipart/form-data'}
    }).then((res) => {
      cart.updateWidget()
    })
  },
  empty: function () {
    return axios.post('/cart/empty/')
  },
  updateWidget: function() {
    axios.get('/cart/cart-widget/')
      .then(res => {
        CartWidget.innerHTML = res.data
      })
  },
};

const createSpinner = function () {
  let spinner = document.createElement('span')
  spinner.className = 'spinner-border spinner-border-sm'
  spinner.setAttribute('role', 'status')
  spinner.setAttribute('aria-hidden', true)
  return spinner
}

const CartOffCanvas = new Offcanvas('#OffCanvasCart')

const attachAddToCartEventListener = (item) => {
  item.addEventListener('click', (e) => {
    let spinner = createSpinner();
    item.prepend(spinner);

    let q = 1
    let pid = item.dataset.pid

    cart.add(pid, q).then(res => {
      axios.get('/api/modals/cart/')
        .then(res => {
          cart.updateWidget()
          OffCanvasCartItems.innerHTML = res.data
          CartOffCanvas.show()

          setTimeout(function() {spinner.remove()}, 200)
        })
    })
  })
}

document.querySelectorAll('.add-to-cart').forEach((item) => {
    attachAddToCartEventListener(item)
})

window.removeFromCart = (event, pid) => {
  event.preventDefault()
  cart.remove(pid).then(res => {
    axios.get('/api/modals/cart/')
        .then(res => {
          cart.updateWidget()
          OffCanvasCartItems.innerHTML = res.data
        })
  })
}

CartWidget.addEventListener('click', () => {
  axios.get('/api/modals/cart/')
    .then(res => {
      OffCanvasCartItems.innerHTML = res.data
      CartOffCanvas.show()
    })
})

document.querySelectorAll('[data-bs-toggle=tooltip]').forEach((item) => {
  let tooltip = new Tooltip(item)
})

document.querySelectorAll('.show-more').forEach((item) => {
  item.addEventListener('click', (e) => {
    let href = item.dataset.href
    let spinner = createSpinner();
    item.prepend(spinner);
    axios.get(href)
      .then(res => {
        console.log(res)
        document.querySelectorAll('.pagination-container').forEach(e => e.remove())
        let nodes = createElementFromHTML(res.data)
        nodes.querySelectorAll('.add-to-cart').forEach((item) => {
          attachAddToCartEventListener(item)
        })
        document.querySelector('.products').append(nodes)

      })
  })
})


/////////////////////////////////
// SEARCH OVERLAY
const searchTriggerBttn = document.getElementById('SearchToggle')
const searchOverlay = document.getElementById('SearchOverlay')
const searchCloseBttn = document.getElementById('SearchCloseButton')
const searchTerm = document.getElementById('SearchTerm')
let searchOverlayOpen = false;



function toggleSearchOverlay() {
  let cl = searchOverlay.classList

  if (cl.contains('open')) {
    cl.remove('open')
    searchOverlayOpen = false
    // bodyScrollLock.clearAllBodyScrollLocks();
  }
  else if (!cl.contains('close')) {
    cl.add('open');
    setTimeout(() => {
      console.log(searchTerm)
      console.log('focues')
      SearchTerm.focus()
    }, 300);
    searchOverlayOpen = true
    // bodyScrollLock.disableBodyScroll(document.querySelector('#id_search_overlay'));
  }
}
if (searchTriggerBttn != null) {
  searchTriggerBttn.addEventListener('click', toggleSearchOverlay);
}
if (searchCloseBttn != null) {
  searchCloseBttn.addEventListener('click', toggleSearchOverlay);
}

document.onkeydown = (evt) => {
  evt = evt || window.event;
  var isEscape = false;
  if ('key' in evt) {
    isEscape = (evt.key === "Escape" || evt.key === "Esc");
  } else {
    isEscape = (evt.keyCode === 27);
  }
  if (isEscape) {
    if (searchOverlayOpen) {
      toggleSearchOverlay()
    }
  }
};

const UtilityModal = new Modal('#UtilityModal')
document.querySelectorAll('.design-container .item-card').forEach((item) => {
  item.addEventListener('click', (e) => {
    UtilityModalTitle.innerHTML = 'Заказ проекта'
    UtilityModalFooter.innerHTML = '\
      <button type="button" class="btn btn-primary fw-bold" data-bs-dismiss="modal" aria-label="Close">Оставить заявку</button> \
    '
    UtilityModalBody.innerHTML = item.querySelector('p').innerText + ' \
      <form id="RequestDesignForm" class="form" action="/request-design/"> \
        <p class="h5 pt-3">Расскажите о себе</p> \
        <input type="text" class="form-control mb-3" name="name" value="" placeholder="Ваше имя"> \
        <input type="text" class="form-control mb-3" name="contact" value="" placeholder="Телефон или e-mail"> \
        \
        <textarea class="form-control" name="comment">Расскажите пару слов о задаче... \
        </textarea> \
      </form> \
    '
    console.log(UtilityModalBody.querySelector('form'))
    UtilityModal.show()
  })
})


// const backgroundElement = document.querySelector('#WaveBG')
// window.onscroll = (e) => {
//   const minScroll = window.innerHeight
//   const maxScroll = document.body.clientHeight - minScroll

//   const determinePercentage = (scroll) => {
//     return Math.floor((actualScroll * 100) / maxScroll)
//   }

//   const actualScroll = Math.floor(window.scrollY)
//   const actualPercentage = determinePercentage(actualScroll)
//   console.log(actualPercentage)


//   backgroundElement.style.cssText = 'position:absolute;width:30%;background:url("/static/assets/wave.png") no-repeat;background-position:center ${actualPercentage}%;background-size:auto 70%;top:0;right:0;height:100%;'
// }
